// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { SortTypeEnum } from '~/utils/enum/common';
import { SANTA_GRAY_500, SLATE_700 } from '~/utils/constants/color';
// Styles, images, icons
import styles from './Sort.module.scss';
import { CommonIconArrow } from '~/assets/svgComponents';

type Props = {
  name: string;
  sortType?: string;
  sortValue?: string;
  handleSort: (sortType: string, name: string, sortValue: string) => void;
};

const cx = classNames.bind(styles);

const Sort = (props: Props) => {
  //#region Destructuring Props
  const { name, sortType, handleSort, sortValue } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [typeSort, setTypeSort] = useState<string>(EMPTY_STRING);
  const [valueSort, setValueSort] = useState<string>(EMPTY_STRING);
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (sortType) {
      setTypeSort(sortType);
    } else {
      setTypeSort(EMPTY_STRING);
    }
  }, [sortType]);

  useEffect(() => {
    if (sortValue) {
      setValueSort(sortValue);
    } else {
      setValueSort(EMPTY_STRING);
    }
  }, [sortValue]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleClickSort = () => {
    const newSortType = typeSort === SortTypeEnum.ASC ? SortTypeEnum.DESC : SortTypeEnum.ASC;
    handleSort(newSortType, name, valueSort);
  };
  //#endregion Handle Function

  return (
    <Box id='sortComponent' className={cx('container')} onClick={() => handleClickSort()}>
      <Box>
        <CommonIconArrow
          fill={typeSort === EMPTY_STRING ? SLATE_700 : typeSort === SortTypeEnum.ASC ? SLATE_700 : SANTA_GRAY_500}
        />
      </Box>
      <Box className={cx('icon')}>
        <CommonIconArrow
          fill={typeSort === EMPTY_STRING ? SLATE_700 : typeSort === SortTypeEnum.DESC ? SLATE_700 : SANTA_GRAY_500}
        />
      </Box>
    </Box>
  );
};

export default Sort;
